// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { connect } from 'react-redux';
import { getUserId } from 'conversations-thread-data/auth/public/selectors';
const mapStateToProps = state => ({
  userId: getUserId(state)
});
const mapDispatchToProps = {};
export const withUserId = connect(mapStateToProps, mapDispatchToProps);